// extracted by mini-css-extract-plugin
export default {"authButton":"Button-module__authButton___dQ3oB","facebook":"Button-module__facebook___D6pVR","apple":"Button-module__apple___tQmWc","google":"Button-module__google___dLfoq"};